var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useController, useFormContext } from 'react-hook-form';
import withDesign from '../../../hocs/withDesign';
import { Select } from '../../molecules/Select';
import { SelectTags } from '../../molecules/SelectTags';
export var FormSelectComponent = function (_a) {
    var name = _a.name, required = _a.required, onChange = _a.onChange, onBlur = _a.onBlur, id = _a.id, value = _a.value, defaultValue = _a.defaultValue, type = _a.type, props = __rest(_a, ["name", "required", "onChange", "onBlur", "id", "value", "defaultValue", "type"]);
    if (!name) {
        throw new Error('Missing prop name on FormSelect');
    }
    var control = useFormContext().control;
    // field: { onChange, onBlur, name, value, ref },
    // fieldState: { invalid, isTouched, isDirty },
    // formState: { touchedFields, dirtyFields },
    var field = useController({
        name: name,
        control: control,
        rules: { required: required },
        defaultValue: defaultValue,
    }).field;
    var ref = field.ref, controllerProps = __rest(field, ["ref"]);
    if (type === 'tags') {
        return _jsx(SelectTags, __assign({ id: id !== null && id !== void 0 ? id : name, value: value }, props, controllerProps));
    }
    return _jsx(Select, __assign({ id: id !== null && id !== void 0 ? id : name, value: value }, props, controllerProps));
};
export var FormSelect = withDesign(FormSelectComponent);
FormSelect.displayName = 'FormSelect';
